import React from 'react'
import { Grid, Stack } from '@mui/material'
import { UseFormReturn } from 'react-hook-form'
import CardActions from '../../../components/CardActions'
import { SectionBox } from '../../../components/FieldView'
import { ControlledTextField, ControlledDatePicker } from "../../../../../components/forms";
import { OperacionNOTESFields } from '../types/fields';

interface SeccionNuevoNOTESDatosSeccionesProps {
  formMethods: UseFormReturn<any>
}

const SeccionNuevoNOTESDatosSecciones = ({ formMethods }: SeccionNuevoNOTESDatosSeccionesProps) => {
  const { control } = formMethods

  return (
    <Stack gap={2}>
      <CardActions title='Sección - Información General' icon='mdi:information-outline' colapsable>
        <SectionBox>
          <Grid item xs={12} md={4}>
            <ControlledTextField label='Tipo de Nota' name={OperacionNOTESFields.TipoNota} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <ControlledTextField label='Cliente' name={OperacionNOTESFields.Cliente} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <ControlledTextField label='Capital a suscribir' name={OperacionNOTESFields.CapitalASuscribir} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <ControlledTextField label='Moneda' name={OperacionNOTESFields.Moneda} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <ControlledDatePicker label='Vencimiento' name={OperacionNOTESFields.Vencimiento} control={control} />
          </Grid>
          <Grid item xs={12} md={4}>
            <ControlledDatePicker label='Fecha de Emisión' name={OperacionNOTESFields.FechaEmision} control={control} />
          </Grid>
          <Grid item xs={12}>
            <ControlledTextField label='Emisor' name={OperacionNOTESFields.Emisor} control={control} fullWidth />
          </Grid>
        </SectionBox>
      </CardActions>

      <CardActions title='Sección Sub-yacentes' icon='mdi:chart-scatter-plot' colapsable>
        <SectionBox>
          <Grid item xs={12}>
            <ControlledTextField label='Subyacentes' name={OperacionNOTESFields.Subyacentes} control={control} fullWidth />
          </Grid>
          <Grid item xs={12}>
            <ControlledTextField label='Observaciones adicionales' name={OperacionNOTESFields.ObsSubyacentes} control={control} fullWidth multiline rows={2} />
          </Grid>
        </SectionBox>
      </CardActions>

      <CardActions title='Sección Cupón' icon='mdi:percent' colapsable>
        <SectionBox>
          <Grid item xs={12} md={4}>
            <ControlledTextField label='Cupón' name={OperacionNOTESFields.Cupon} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <ControlledTextField label='Frecuencia de pago' name={OperacionNOTESFields.FrecuenciaPago} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <ControlledTextField label='Condición de pago' name={OperacionNOTESFields.CondicionPago} control={control} fullWidth />
          </Grid>
          <Grid item xs={12}>
            <ControlledTextField label='Observaciones adicionales' name={OperacionNOTESFields.ObsCupon} control={control} fullWidth multiline rows={2} />
          </Grid>
        </SectionBox>
      </CardActions>

      <CardActions title='Sección Participación' icon='mdi:account-group-outline' colapsable>
        <SectionBox>
          <Grid item xs={12} md={4}>
            <ControlledTextField label='Participación' name={OperacionNOTESFields.Participacion} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <ControlledTextField label='Forma de participación' name={OperacionNOTESFields.FormaParticipacion} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <ControlledTextField label='Descripción de la participación' name={OperacionNOTESFields.DescripcionParticipacion} control={control} fullWidth />
          </Grid>
          <Grid item xs={12}>
            <ControlledTextField label='Observaciones adicionales' name={OperacionNOTESFields.ObsParticipacion} control={control} fullWidth multiline rows={2} />
          </Grid>
        </SectionBox>
      </CardActions>

      <CardActions title='Sección Protección de Capital' icon='mdi:shield-outline' colapsable>
        <SectionBox>
          <Grid item xs={12} md={4}>
            <ControlledTextField label='Tipo de protección' name={OperacionNOTESFields.TipoProteccion} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <ControlledTextField label='Nivel de protección' name={OperacionNOTESFields.NivelProteccion} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <ControlledTextField label='Descripción de la protección' name={OperacionNOTESFields.DescripcionProteccion} control={control} fullWidth />
          </Grid>
          <Grid item xs={12}>
            <ControlledTextField label='Observaciones adicionales' name={OperacionNOTESFields.ObsProteccion} control={control} fullWidth multiline rows={2} />
          </Grid>
        </SectionBox>
      </CardActions>

      <CardActions title='Sección Rescate Anticipado' icon='mdi:calendar-remove-outline' colapsable>
        <SectionBox>
          <Grid item xs={12} md={4}>
            <ControlledTextField label='Barrera de rescate anticipado' name={OperacionNOTESFields.BarreraRescateAnticipado} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <ControlledTextField label='Condición de rescate anticipado' name={OperacionNOTESFields.CondicionRescateAnticipado} control={control} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <ControlledTextField label='Frecuencia de observación' name={OperacionNOTESFields.FrecuenciaObservacion} control={control} fullWidth />
          </Grid>
          <Grid item xs={12}>
            <ControlledTextField label='Observaciones adicionales' name={OperacionNOTESFields.ObsRescateAnticipado} control={control} fullWidth multiline rows={2} />
          </Grid>
        </SectionBox>
      </CardActions>
    </Stack>
  )
}

export default SeccionNuevoNOTESDatosSecciones
